import { CONTENT_TYPE } from "../constants/conf";
var createHttpRejection = function createHttpRejection(params) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'http request fail.';
  var rejection = new Error(message);
  var xhr = params.xhr;
  var detail = {
    type: 'ajax',
    response: null,
    event: params.event,
    data: params.data,
    xhr: xhr,
    status: xhr.status,
    responseText: xhr.responseText
  };
  try {
    detail.response = JSON.parse(xhr.responseText);
  } catch (error) {
    // nothing todo...
  }
  return Object.assign(rejection, {
    detail: detail
  });
};
var httpRequest = function httpRequest(url, data) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.onerror = function (event) {
      var rejection = createHttpRejection({
        xhr: xhr,
        event: event,
        data: data
      });
      reject(rejection);
    };
    xhr.onreadystatechange = function (event) {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        resolve();
      } else {
        var rejection = createHttpRejection({
          xhr: xhr,
          event: event,
          data: data
        });
        if (xhr.status >= 500 || xhr.status >= 402 && xhr.status <= 420 || xhr.status == 400 || xhr.status == 401) {
          reject(rejection);
        }
      }
    };
    xhr.setRequestHeader('Content-Type', CONTENT_TYPE);
    xhr.withCredentials = false;
    xhr.send(data);
  });
};
export default httpRequest;